import configure from "configure"
import moment from "moment"
import React from "react"
import { Link } from "react-router-dom"
import { Badge, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap"

import indiaFlag from '../../../assets/images/flags/india.png'
import ukFlag from '../../../assets/images/flags/uk.png'
import usaFlag from '../../../assets/images/flags/usa.png'
import { Tooltip } from "antd"
export const pendingInvoiceColumns = (onPaymentRecord, onCovertTax, onDownloadReceipt, status, isPrivilegedUser) => [
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center id-col",
    },
    {
        Header: "Date",
        accessor: "invoice_date",
        isInfoIcon: false,
        className: "text-center date-col",
        Cell: cellProps => {
            return (
                <>
                    {moment(cellProps.row.original.invoice_date).format("DD-MM-YYYY")}
                </>
            )
        },
    },
    {
        Header: "PRF Invoice",
        accessor: "invoice_number",
        grow: false,
        className: "prf_invoice_box text-center",
        isInfoIcon: true,
        Cell: cellProps => {
            const invNo = cellProps?.row?.original?.status == 1 && status == 'ztpl' ? cellProps?.row?.original?.tax_inv_no : cellProps?.row?.original?.invoice_number
            return (
                <div>{invNo}</div>
            )
        }
    },

    {
        Header: "Customer",
        accessor: "company",
        isInfoIcon: true,
        className: "customer-col",
        Cell: row => <div>{row.value}</div>,
    },
    {
        Header: "Due Date",
        accessor: "due_date",
        isInfoIcon: false,
        className: "text-center due_date-col",
        Cell: cellProps => {
            return (
                <>{moment(cellProps.row.original.due_date).format("DD-MM-YYYY")}</>
            )
        },
    },
    {
        Header: "Amount",
        accessor: "total",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: ({ row }) => {
            return (
                <div>{row?.original?.currency_symbol} {Number(row?.original?.total).toFixed(2) || 0}</div>
            )
        }
    },
    ...(status === 'ztpl'
        ? [
            {
                Header: "GST",
                accessor: "gst",
                isInfoIcon: true,
                className: "text-center amount-col",
                Cell: cellProps => {
                    const value = cellProps?.row?.original;
                    const total = Number(value?.igst) + Number(value?.cgst) + Number(value?.sgst);
                    return <div>{Number(total).toFixed(2)}</div>;
                },
            },
        ]
        : []),
    {
        Header: "Due Amt.",
        accessor: "due_amount",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: row => <div>{Number(row?.value).toFixed(2) || 0}</div>,
    },
    {
        Header: "Action",
        accessor: "action",
        className: "text-center col-md-1",
        Cell: cellProps => {
            return (
                <div className="d-flex justify-content-center">
                    {status == 'ztpl' ? (
                        <>
                            {cellProps?.row?.original?.status == 0 ? (
                                <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Convert to Tax"
                                    style={{ color: "rgb(117, 42, 151)" }} onClick={() => onCovertTax(cellProps?.row?.original?.id)}><i className="fas fa-sync-alt "></i> Tax</a>
                            ) : cellProps?.row?.original?.status == 1 && cellProps?.row?.original?.due_flag == 0 ? (
                                isPrivilegedUser ? (
                                    <button
                                        className="btn btn-sm me-1 btn-outline-secondary"
                                        title="Payment Record"
                                        onClick={() => onPaymentRecord(cellProps?.row?.original)}
                                    >
                                        <i className="fas fa-credit-card "></i>
                                    </button>
                                ) : (
                                    <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Download Receipt"
                                        style={{ color: "rgb(117, 42, 151)" }} onClick={() => onDownloadReceipt(cellProps?.row?.original)}><i className="fas fa-download"></i> Receipt</a>
                                )
                            ) : cellProps?.row?.original?.due_flag == 1 && cellProps?.row?.original?.receipt_status == 0 ? (
                                <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Download Receipt"
                                    style={{ color: "rgb(117, 42, 151)" }} onClick={() => onDownloadReceipt(cellProps?.row?.original)}>   <i className="fas fa-download"></i> Receipt</a>
                            ) : null}
                        </>
                    ) : (
                        <>
                            {cellProps?.row?.original?.due_flag == 1 ? (
                                <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Download Receipt"
                                    style={{ color: "rgb(117, 42, 151)" }} onClick={() => onDownloadReceipt(cellProps?.row?.original)}>   <i className="fas fa-download"></i> Receipt</a>
                            ) : isPrivilegedUser ? (
                                <button
                                    className="btn btn-sm me-1 btn-outline-secondary"
                                    title="Payment Record"
                                    onClick={() => onPaymentRecord(cellProps?.row?.original)}
                                >
                                    <i className="fas fa-credit-card "></i>
                                </button>
                            ) : (
                                <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Download Receipt"
                                    style={{ color: "rgb(117, 42, 151)" }} onClick={() => onDownloadReceipt(cellProps?.row?.original)}><i className="fas fa-download"></i> Receipt</a>
                            )}
                        </>
                    )}

                </div>
            )
        },
    },
]

export const ReceiptsInvoiceColumns = (onPaymentRecord, onCovertTax, onDownloadReceipt, status) => [
    {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center id-col",
    },
    {
        Header: "Date",
        accessor: "invoice_date",
        isInfoIcon: false,
        className: "text-center date-col",
        Cell: cellProps => {
            return (
                <>
                    {moment(cellProps.row.original.invoice_date).format("DD-MM-YYYY")}
                </>
            )
        },
    },
    {
        Header: "Invoice No.",
        accessor: "invoice_number",
        grow: false,
        className: "prf_invoice_box text-center",
        isInfoIcon: true,
        Cell: cellProps => {
            console.log("status: ", cellProps?.row?.original?.status);
            const invNo = cellProps?.row?.original?.status == 1 ? cellProps?.row?.original?.tax_inv_no : cellProps?.row?.original?.invoice_number
            console.log("invNo: ", invNo);
            return (
                <div>{invNo}</div>
            )
        }
    },

    {
        Header: "Customer",
        accessor: "company",
        isInfoIcon: true,
        className: "customer-col",
        Cell: row => <div>{row.value}</div>,
    },
    {
        Header: "Due Date",
        accessor: "due_date",
        isInfoIcon: false,
        className: "text-center due_date-col",
        Cell: cellProps => {
            return (
                <>{moment(cellProps.row.original.due_date).format("DD-MM-YYYY")}</>
            )
        },
    },
    {
        Header: "Amount",
        accessor: "total",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: ({ row }) => {
            return (
                <div>{row?.original?.currency_symbol} {Number(row?.original?.total).toFixed(2) || 0}</div>
            )
        }
    },
    ...(status === 'ztpl'
        ? [
            {
                Header: "GST",
                accessor: "gst",
                isInfoIcon: true,
                className: "text-center amount-col",
                Cell: cellProps => {
                    const value = cellProps?.row?.original;
                    const total = Number(value?.igst) + Number(value?.cgst) + Number(value?.sgst);
                    return <div>{Number(total).toFixed(2)}</div>;
                },
            },
        ]
        : []),
    {
        Header: "Due Amt.",
        accessor: "due_amount",
        isInfoIcon: true,
        className: "text-center amount-col",
        Cell: row => <div>{Number(row?.value).toFixed(2) || 0}</div>,
    },
    {
        Header: "Action",
        accessor: "action",
        className: "text-center col-md-1",
        Cell: cellProps => {
            return (
                <div className="d-flex justify-content-center">
                    {status == 'ztpl' ? (
                        <>
                            {cellProps?.row?.original?.status == 0 ? (
                                <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Convert to Tax"
                                    style={{ color: "rgb(117, 42, 151)" }} onClick={() => onCovertTax(cellProps?.row?.original?.id)}><i className="fas fa-sync-alt "></i> Tax</a>
                            ) : cellProps?.row?.original?.status == 1 && cellProps?.row?.original?.due_flag == 0 ? (

                                <button
                                    className="btn btn-sm me-1 btn-outline-secondary"
                                    title="Payment Record"
                                    onClick={() => onPaymentRecord(cellProps?.row?.original)}
                                >
                                    <i className="fas fa-credit-card "></i>
                                </button>
                            ) : cellProps?.row?.original?.due_flag == 1 && cellProps?.row?.original?.receipt_status == 0 ? (
                                <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Download Receipt"
                                    style={{ color: "rgb(117, 42, 151)" }} onClick={() => onDownloadReceipt(cellProps?.row?.original)}>   <i className="fas fa-download"></i> Receipt</a>
                            ) : null}
                        </>
                    ) : (
                        <>
                            {cellProps?.row?.original?.due_flag == 1 ? (
                                <a className="btn btn-sm  bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="Download Receipt"
                                    style={{ color: "rgb(117, 42, 151)" }} onClick={() => onDownloadReceipt(cellProps?.row?.original)}>   <i className="fas fa-download"></i> Receipt</a>
                            ) : (
                                <button
                                    className="btn btn-sm me-1 btn-outline-secondary"
                                    title="Payment Record"
                                    onClick={() => onPaymentRecord(cellProps?.row?.original)}
                                >
                                    <i className="fas fa-credit-card "></i>
                                </button>
                            )}
                        </>
                    )}

                </div>
            )
        },
    },
]

export const requestedInvoiceColumns = (onCreateCustomer, onCreateInvoice, onInvoicePaid) => [
    {
        Header: "ID",
        accessor: "id",
        className: "",
        isShortIcon: true,
    },
    {
        Header: "Assign",
        accessor: "assign",
        className: "",
        isShortIcon: true,
        Cell: cellProps => {
            return (
                <div className="text-center d-flex align-items-center">
                    <div className="profileImg-box">
                        <img
                            src={`${configure.imgUrl}${cellProps.row.original.asigned_avatar}`}
                            alt=""
                            className="assigned-img mx-1"
                            height="20"
                            width="20"
                        />
                    </div>
                    {cellProps.row.original.lead_belongs_to == 1 ? (
                        <img
                            src={indiaFlag}
                            className=" mx-1 location-img"
                            alt="flag"
                            height="15"
                            width="20"
                        />
                    ) : cellProps.row.original.lead_belongs_to == 2 ? (
                        <img
                            src={ukFlag}
                            className=" mx-1 location-img"
                            alt="flag"
                            height="15"
                            width="20"
                        />
                    ) : (
                        <img
                            src={usaFlag}
                            className=" mx-1 location-img"
                            alt="flag"
                            height="15"
                            width="20"
                        />
                    )}
                </div>
            )
        },
    },
    {
        Header: "Company",
        accessor: "company",
        className: "",
        isShortIcon: true,
        Cell: cellProps => {
            return (
                <div className="d-flex justify-space-between align-items-center">
                    <Tooltip color={"#752b97"} title={`Service : ${cellProps.row.original?.service != null ? cellProps.row.original?.service : 'Not Defined'}`}>
                        <div>
                            {cellProps.row.original.company !== null
                                ? cellProps.row.original.company
                                : "-"}
                        </div>
                    </Tooltip>
                </div>
            )
        },
    },
    {
        Header: "Name",
        accessor: "person_details",
        className: "",
        isShortIcon: true,
        Cell: cellProps => {
            const personal = JSON.parse(cellProps.row.original.person_details)
            let PersonName
            if (personal != null && personal?.length == 0) {
                PersonName = "-"
            } else if (personal != null) {
                PersonName = personal[0]?.person_name
            }
            return <div>{PersonName ? PersonName : "-"}</div>
        },
    },
    {
        Header: "Email ID",
        accessor: "email",
        className: "",
        isShortIcon: true,
        Cell: cellProps => {
            const alldata = cellProps.row.original
            return (
                <div>
                    {alldata?.person_details
                        ? JSON.parse(alldata.person_details)[0]?.person_email
                            ? JSON.parse(alldata.person_details)[0].person_email
                            : alldata?.email != null
                                ? alldata?.email
                                : "-"
                        : alldata?.email != null
                            ? alldata?.email
                            : "-"}
                </div>
            )
        },
    },
    {
        Header: "Phone",
        accessor: "phone",
        className: "",
        isShortIcon: true,
        Cell: cellProps => {
            const alldata = cellProps.row.original
            return (
                <div>
                    {alldata?.person_details
                        ? JSON.parse(alldata.person_details)[0]?.person_phone
                            ? JSON.parse(alldata.person_details)[0].person_phone
                            : alldata?.phonenumber != null
                                ? alldata?.phonenumber
                                : "-"
                        : alldata?.phonenumber != null
                            ? alldata?.phonenumber
                            : "-"}
                </div>
            )
        },
    },
    {
        Header: "Status",
        accessor: "status",
        className: "",
        isShortIcon: true,
        Cell: cellProps => {
            return (
                <Badge className={cellProps.row.original.status_color}>
                    {cellProps.row.original.sname}
                </Badge>
            )
        },
    },
    {
        Header: "Action",
        className: "pend-action",
        Cell: ({ row }) => {
            return (
                <div className="d-flex justify-content-center">
                    {row.original.ctp_status == 1 && row?.original?.customer_type != 'existing' ? (
                        <a className="btn btn-sm bg-light-purple text-purple border-0 pt-2 pb-2 pe-2 ps-2" title="View Project" style={{ color: "rgb(117, 42, 151)" }}
                            onClick={() => onCreateCustomer(row?.original?.id)}>Create Customer</a>
                    ) : row.original.ctp_status == 2 || row?.original?.customer_type == 'existing' ? (
                        <div className="d-flex gap-2 align-items-center">
                            <UncontrolledDropdown
                                className="dropdown"
                            >
                                <DropdownToggle
                                    className="btn btn-sm bg-light-success text-success border-0 pt-2 pb-2 pe-1 ps-1"
                                    color="white"
                                >
                                    Create Invoice
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                    <a
                                        onClick={() => onCreateInvoice('ztpl', row?.original)}
                                        className="dropdown-item"
                                        title="Ztpl Invoice"
                                    >
                                        <i className="bx bx-receipt me-2 "></i>{" "}
                                        ZTPL Invoice
                                    </a>
                                    <a
                                        onClick={() => onCreateInvoice('zithas', row?.original)}
                                        className="dropdown-item"
                                        title="Zithas Invoice"
                                    >
                                        <i className="bx bx-receipt me-2"></i>
                                        Zithas Invoice
                                    </a>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                            {row?.original?.customer_type != 'existing' ? (
                                <a className="btn btn-sm btn-outline-primary me-1" title="Edit Customer"
                                    onClick={() => onCreateCustomer(row?.original?.id, 'edit', row?.original)}
                                >
                                    <i className="fa fa-users"></i>
                                </a>
                            ) : null}
                        </div>
                    ) : row.original.ctp_status == 3 ? (
                        <div className="d-flex gap-2 align-items-center">
                            <a className="btn btn-sm me-1 btn-outline-primary" onClick={() => onInvoicePaid(row?.original)}>
                                <i className="fas fa-credit-card me-2"></i> Invoice Paid
                            </a>
                            {row?.original?.customer_type != 'existing' ? (
                                <a className="btn btn-sm btn-outline-primary me-1" title="Edit Customer"
                                    onClick={() => onCreateCustomer(row?.original?.id, 'edit', row?.original)}
                                >
                                    <i className="fa fa-users"></i>
                                </a>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            )
        }
    },
];